import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { seoApi } from '../lib/api';

// Cache SEO settings in-memory across route changes
let CACHED = null;
let PENDING = null;
async function getSeoOnce() {
  if (CACHED) return CACHED;
  if (!PENDING) PENDING = seoApi.getPublic().catch(() => ({}));
  CACHED = await PENDING;
  return CACHED;
}

export function invalidateSeoCache() {
  CACHED = null;
  PENDING = null;
}

export default function Seo({ pageKey, title, description, keywords }) {
  const [remote, setRemote] = useState(null);

  useEffect(() => {
    let alive = true;
    getSeoOnce().then((data) => { if (alive) setRemote(data); });
    return () => { alive = false; };
  }, []);

  const settings = (remote && pageKey && remote[pageKey]) || {};
  const finalTitle = title || settings.title || 'EasySpanishInsurance';
  const finalDesc = description || settings.description || '';
  const finalKw = keywords || settings.keywords || '';

  return (
    <Helmet>
      <title>{finalTitle}</title>
      {finalDesc && <meta name="description" content={finalDesc} />}
      {finalKw && <meta name="keywords" content={finalKw} />}
      <meta property="og:title" content={finalTitle} />
      {finalDesc && <meta property="og:description" content={finalDesc} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      {finalDesc && <meta name="twitter:description" content={finalDesc} />}
    </Helmet>
  );
}
